import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';
import HalideHero from '../components/HalideHero';
import SimchaSection from '../components/SimchaSection';
import ImageGallery from '../components/ImageGallery';
import DottedSurface from '../components/DottedSurface';
import useSeo from '../hooks/useSeo';

export default function Home() {
  useSeo({
    title: 'Custom Jewish Simcha Invitations — Bar Mitzvah, Wedding, Bris',
    description: "Personalize and download beautiful printable Jewish invitations for every simcha — Bar Mitzvah, Bat Mitzvah, Wedding, Engagement, Bris, Vach Nacht, Pidyon HaBen, Sheva Brachos. Hebrew & English templates, instant download from $18.99.",
    path: '/',
  });

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get('/categories/GetAllCategoriesAndSubCategories')
      .then(r => setCategories(unwrap(r)?.categories || []))
      .catch(() => {});
  }, []);

  return (
    <>
      <HalideHero />

      <SimchaSection categories={categories} />

      <ImageGallery />

      <DottedSurface>
        <section id="custom-design" className="convenience-simcha-container">
          <div className="convenience-simcha-centered">
            <div className="convenience-block">
              <h2>Simple. Beautiful. Yours.</h2>
              <p>It's a Simcha was built to take the stress out of invitations. Pick a template, type in your details, and you're done — ready to print, share, or send. No design software. No back-and-forth. Just a beautiful invitation, in minutes.</p>
              <p className="pricing-text">All templates start at just <strong>$18.99</strong> — designer-quality invites without the designer price tag.</p>
              <p className="closing-text">Let the simcha begin!</p>
            </div>
          </div>
        </section>
      </DottedSurface>
    </>
  );
}
